import { AdvancedSearchURLParams } from '@ltvco/refresh-lib/v2';
import React, { useEffect } from 'react';

import { PACERDocketResult } from 'routes/Dashboard/CourtCases';
import { useCourtSearch } from 'routes/Dashboard/CourtCases/api';

interface CourtCaseFetcherProps {
  searchData: AdvancedSearchURLParams;
  setCourtCaseResults: (results: PACERDocketResult[]) => void;
  /** Notify parent when the court case search is in progress */
  onLoadingChange?: (loading: boolean) => void;
}

export function CourtCaseFetcher({
  searchData,
  setCourtCaseResults,
  onLoadingChange,
}: CourtCaseFetcherProps) {
  const query =
    [searchData.fName, searchData.mName, searchData.lName]
      .filter(Boolean)
      .join(' ')
      .trim() ||
    searchData.fullName ||
    searchData.case_name ||
    '';

  const { pacerResults, triggerCombinedSearch, isSearching } = useCourtSearch(
    '',
    false
  );

  useEffect(() => {
    if (query.trim()) {
      triggerCombinedSearch(query, {});
    }
  }, [query]);

  useEffect(() => {
    if (!isSearching && pacerResults?.results) {
      setCourtCaseResults(pacerResults.results);
    } else if (!isSearching && !pacerResults) {
      setCourtCaseResults([]);
    }
  }, [pacerResults, isSearching, setCourtCaseResults]);

  useEffect(() => {
    onLoadingChange?.(isSearching);
    return () => {
      onLoadingChange?.(false);
    };
  }, [isSearching, onLoadingChange]);

  return <React.Fragment />;
}
